module.exports = __webpack_public_path__ + "src/assets/img/header_wissen_10_em_green_en.bbe2c158.png";